module.exports = __webpack_public_path__ + "static/35-0416c553cf48e8bd458846b441d55b59.mp4";